import React from 'react';
import styles from './table.module.scss';
import DatePicker from "react-datepicker";

export default class TableEditableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, { item: props.item, isEditing: false });
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleSaveRowClick = this.handleSaveRowClick.bind(this);
        this.handleValueChanged = this.handleValueChanged.bind(this);
    }

    handleEditClick(e) {
        e.preventDefault();
        if (this.props.isEditableRow) {
            this.setState({ ...this.state, isEditing: true });
        } else {
            this.props.editItemFunction(this.state.item);
        }
    }

    handleSaveRowClick(e) {
        e.preventDefault();
        this.setState({ ...this.state, isEditing: false });
        this.props.editItemFunction(this.state.item);
    }

    handleValueChanged(value, propName) {
        const newState = Object.assign({}, this.state);
        newState.item[propName] = value;
        this.setState(newState);
    }

    renderDate(value) {
        const date = new Date(value.split('.')[0] + ".000Z");
        const stringDate = ("0" + date.getDate()).slice(-2) +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            date.getFullYear() +
            " " +
            ("0" + date.getHours()).slice(-2) +
            ":" +
            ("0" + date.getMinutes()).slice(-2) + ":" +
            ("0" + date.getSeconds()).slice(-2);

        return (<div>{stringDate}</div>);
    }

    renderText(value) {
        return (<div>{value}</div>);
    }

    renderInt(value) {
        return (<div>{value}</div>);
    }

    renderFloat(value) {
        value = value.toFixed(2);
        return (<div>{value}</div>);
    }

    renderEditableInt(value, propName) {
        return (
            <div>
                <input type="number" value={value} onChange={(e) => this.handleValueChanged(value, propName)} />
            </div>
        );
    }

    renderEditableInt(value, propName) {
        return (
            <div>
                <input type="number" value={value} onChange={(e) => this.handleValueChanged(e.target.value, propName)} />
            </div>
        );
    }

    renderEditableFloat(value, propName) {
        value = value.toFixed(2);
        return (
            <div>
                <input type="number" value={value} step="0.01" onChange={(e) => this.handleValueChanged(e.target.value, propName)} />
            </div>
        );
    }

    renderEditableText(value, propName) {
        return (
            <div>
                <input type="text" value={value} onChange={(e) => this.handleValueChanged(e.target.value, propName)} />
            </div>
        );
    }
    renderEditableDateTime(value, propName) {
        return (
            <div>
                <DatePicker selected={value} onChange={date =>
                    this.handleValueChanged(date, propName)} />
            </div>
        );
    }

    renderCell(column) {
        const value = this.props.item[column.name];
        const isEditable = this.state.isEditing;
        switch (column.dataType) {
            case "text":
                {
                    if (isEditable) {
                        return this.renderEditableText(value, column.name);
                    }
                    return this.renderText(value);
                }
            case "int":
                {
                    if (isEditable) {
                        return this.renderEditableInt(value, column.name);
                    }
                    return this.renderInt(value);
                }
            case "datetime":
                {
                    if (isEditable) {
                        return this.renderEditableDateTime(value, column.name);
                    }
                    return this.renderDate(value);
                }
            case "float":
                {
                    if (isEditable) {
                        return this.renderEditableFloat(value, column.name);
                    }
                    return this.renderFloat(value);
                }
            default:
                return this.renderText(value);
        }
    }

    render() {
        return (
            <tr>
                {
                    this.props.columns.map((column, index) => <td key={index}>{this.renderCell(column)}</td>)
                }
                {
                    this.props.isEditable && !this.state.isEditing && <td><button className={styles.edit_button} onClick={this.handleEditClick} /></td>
                }
                {
                    this.props.isEditable && this.state.isEditing && <td><button className={styles.ok_button} onClick={this.handleSaveRowClick} /></td>
                }
            </tr>
        );
    }

}